module.exports = __webpack_public_path__ + "img/c04_unittechmountedarcherchampion_Normal_ua.5282bfa2.webp";